export function isHeicCredentialPhoto(file: File): boolean {
  const type = file.type.toLowerCase();
  if (type === "image/heic" || type === "image/heif") return true;
  const name = file.name.toLowerCase();
  return name.endsWith(".heic") || name.endsWith(".heif");
}

export function canUseObjectUrlImagePreview(file: File): boolean {
  if (isHeicCredentialPhoto(file)) return false;
  const type = file.type.toLowerCase();
  if (!type) return true;
  return type.startsWith("image/");
}

export async function createCredentialPhotoPreviewUrl(
  file: File,
): Promise<string> {
  if (!canUseObjectUrlImagePreview(file)) {
    const { default: heic2any } = await import("heic2any");
    const converted = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.85,
    });
    const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
    if (!(jpegBlob instanceof Blob)) {
      throw new Error("Could not convert photo for preview");
    }
    return URL.createObjectURL(jpegBlob);
  }

  return URL.createObjectURL(file);
}

export function revokeCredentialPhotoPreviewUrl(url: string | null): void {
  if (!url || typeof URL.revokeObjectURL !== "function") return;
  if (!url.startsWith("blob:")) return;
  URL.revokeObjectURL(url);
}
